<template>
	<div class="chat-box" @click="onClickChatBox()" @mousemove="readedMessage()">
		<el-container>
			<el-header height="60px" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
				<div class="title">{{ title }}</div>
				<div v-if="conversation.companyName" class="company-tag" :title="conversation.companyName">@{{
					conversation.companyName }}</div>
				<span :title="$t('chat.groupInfo')" class="btn-side el-icon-more" @click="onClickMore"></span>
			</el-header>
			<el-main style="padding: 0;">
				<el-container>
					<el-container class="content-box">
						<div v-if="isGroup && group.topMessage">
							<chat-top-message :group="group" :groupMembers="groupMembers" :message="group.topMessage"
								:headImage="headImage(group.topMessage)" :showName="showName(group.topMessage)"
								@locate="locateMessage">
							</chat-top-message>
						</div>
						<chat-group-rtc-banner v-if="isGroup && group.rtcInfo && group.rtcInfo.isChating"
							:rtcInfo="group.rtcInfo" @join="onGroupVideo()">
						</chat-group-rtc-banner>
						<el-main class="im-chat-main" id="chatScrollBox">
							<div class="im-chat-box" :class="{ 'multi-select-mode': isMultiSelectMode }">
								<div v-if="chatStore.loadingMessage && messages.length" class="loading-message-tip">
									<i class="el-icon-loading"></i>
									<span>{{ $t('common.loading') }}</span>
								</div>
								<div v-for="m in messages" :key="m.localId"
									:class="{ 'message-selected': isMessageSelected(m) }"
									@click="onMessageClick($event, m)">
									<div v-if="isMultiSelectMode && isAllowSelectMessage(m)" class="message-checkbox"
										@click.stop>
										<el-checkbox :value="isMessageSelected(m)"
											@change="toggleMessageSelect(m)"></el-checkbox>
									</div>
									<chat-message-item :id="m.localId" @call="onCall(m.type)"
										:active="activeMessageLocalId == m.localId || isMessageSelected(m)"
										:mine="m.sendId == mine.id" :headImage="headImage(m)" :showName="showName(m)"
										:conversation="conversation" :message="m"
										:quoteShowName="showName(m.quoteMessage)" :group="group"
										:groupMemberMap="groupMemberMap" @locateQuote="onLocateQuoteMessage"
										@copy="onCopyMessage" @resend="onResendMessage" @delete="onDeleteMessage"
										@recall="onRecallMessage" @quote="onQuoteMessage" @top="onTopMessage"
										@forward="onForwardMessage" @multiSelect="onMultiSelectMessage"
										@addSticker="onAddToSticker" @download="onDownloadFile" @atMember="onAtMember">
									</chat-message-item>
								</div>
							</div>
						</el-main>
						<!-- 多选操作工具栏 -->
						<div v-if="isMultiSelectMode" class="multi-select-toolbar">
							<div class="toolbar-info">
								{{ $t('chat.selectedCount', { n: selectedMessages.length }) }}
								<span v-if="selectedMessages.length >= 20" class="max-limit-tip">（{{ $t('chat.maxLimit')
								}}）</span>
							</div>
							<div class="toolbar-actions">
								<el-button size="small" type="primary" @click.stop="onBatchForward"
									:disabled="selectedMessages.length === 0">{{ $t('chat.forwardOneByOne')
									}}</el-button>
								<el-button size="small" type="success" @click.stop="onMergeForward"
									:disabled="selectedMessages.length < 2">{{ $t('chat.mergeForward') }}</el-button>
								<el-button size="small" type="danger" @click.stop="onBatchDelete"
									:disabled="selectedMessages.length === 0">{{ $t('common.delete') }}</el-button>
								<el-button size="small" @click="exitMultiSelectMode">{{ $t('common.cancel')
								}}</el-button>
							</div>
						</div>
						<div v-if="conversation.atMe || conversation.atAll" class="locate-tip"
							@click="scrollToAtMessage">{{
								$t('chat.atMe') }} </div>
						<div v-else-if="!chatStore.isInBottom" class="locate-tip" @click="onScrollToBottom">
							{{ chatStore.newMessageSize > 0 ? $t('chat.newMessages', { n: chatStore.newMessageSize }) :
								$t('chat.backToBottom') }}
						</div>
						<el-footer height="220px" class="im-chat-footer">
							<div class="chat-tool-bar">
								<div :title="$t('chat.emoji')" class="icon iconfont icon-emoji" ref="emotion"
									@click.stop="showEmotionBox()">
								</div>
								<div v-if="configStore.electronMode" :title="$t('chat.screenshotShortcut')"
									class="icon iconfont icon-screenshot" ref="emotion" @click.stop="onScreenshot()">
								</div>
								<i v-if="configStore.electronMode" class="el-icon-caret-bottom"
									@click="onShowScreenshotMenu"></i>
								<div :title="$t('chat.sendImage')">
									<file-upload :action="'/image/upload'" :maxSize="10 * 1024 * 1024"
										:fileTypes="['image/jpeg', 'image/png', 'image/jpg', 'image/webp', 'image/gif']"
										@before="onImageBefore" @success="onImageSuccess" @fail="onImageFail">
										<i class="el-icon-picture-outline"></i>
									</file-upload>
								</div>
								<div :title="$t('chat.sendVideo')">
									<file-upload :action="'/video/upload'" :maxSize="50 * 1024 * 1024"
										:fileTypes="['video/mp4', 'video/ogg', 'video/webm']" @before="onVideoBefore"
										@success="onVideoSuccess" @fail="onVideoFail">
										<i class="el-icon-film"></i>
									</file-upload>
								</div>
								<div :title="$t('chat.sendFile')">
									<file-upload ref="fileUpload" :action="'/file/upload'" :maxSize="10 * 1024 * 1024"
										@before="onFileBefore" @success="onFileSuccess" @fail="onFileFail">
										<i class="el-icon-wallet"></i>
									</file-upload>
								</div>
								<div :title="$t('chat.receiptMsg')" v-show="isGroup" class="icon iconfont icon-receipt"
									:class="isReceipt ? 'chat-tool-active' : ''" @click="onSwitchReceipt">
								</div>
								<div :title="$t('chat.sendVoice')" class="el-icon-microphone" @click="showRecordBox()">
								</div>
								<div :title="$t('chat.voiceCall')" v-show="isPrivate" class="el-icon-phone-outline"
									@click="showPrivateVideo('voice')">
								</div>
								<div :title="$t('chat.groupCall')" v-show="isGroup" class="el-icon-video-camera"
									@click="onGroupVideo()">
								</div>
								<div :title="$t('chat.videoCall')" v-show="isPrivate" class="el-icon-video-camera"
									@click="showPrivateVideo('video')">
								</div>
								<div :title="$t('chat.chatHistory')" class="icon iconfont icon-chat-history"
									@click="showHistoryBox()"></div>
							</div>
							<div class="send-content-area">
								<ChatInput :group="group" ref="chatInputEditor" :group-members="groupMembers"
									@submit="sendMessage" />
								<div v-if="quoteMessage" class="quote-message">
									<chat-quote-message :showName="showName(quoteMessage)" :message="quoteMessage">
									</chat-quote-message>
									<div class="quote-remove" @click="onQuoteMessage(null)"><i
											class="el-icon-close"></i></div>
								</div>
								<div class="send-btn-area">
									<el-button type="primary" icon="el-icon-s-promotion" @click="notifySend()">{{
										$t('common.send') }}</el-button>
								</div>
							</div>
							<div class="chat-editer-mask" v-if="notAllowInputTip">
								<span class="icon el-icon-warning"></span>
								<span>{{ notAllowInputTip }}</span>
							</div>
						</el-footer>
					</el-container>
					<el-aside class="chat-side-box" :class="{ fullscreen: configStore.fullScreen }" width="265px"
						v-if="showSide">
						<chat-group-side v-if="isGroup" :conversation="conversation" :groupId="group.id"
							:groupMembers="groupMembers" @reload="loadGroup(group.id)"></chat-group-side>
						<chat-private-side v-if="isPrivate" :conversation="conversation"
							:userInfo="userInfo"></chat-private-side>
					</el-aside>
				</el-container>
			</el-main>
			<chat-emotion ref="emoBox" @emotion="onEmotion"></chat-emotion>
			<chat-record :visible="showRecord" @close="closeRecordBox" @send="onSendRecord"></chat-record>
			<group-member-selector v-if="isGroup" ref="rtcSel" :title="$t('rtc.inviteMember')" :group="group"
				@complete="onInviteOk"></group-member-selector>
			<chat-selector ref="chatSel" :title="$t('chat.forwardMsg')"></chat-selector>
			<rtc-group-join v-if="isGroup" ref="rtcJoin" :groupId="group.id"></rtc-group-join>
			<chat-history ref="chatHistory" :conversation="conversation" :friend="friend" :group="group"
				@locateQuote="locateMessage" :groupMemberMap="groupMemberMap"></chat-history>
			<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
		</el-container>
	</div>
</template>

<script>
import ChatGroupSide from "./ChatGroupSide.vue";
import ChatPrivateSide from "./ChatPrivateSide.vue";
import ChatMessageItem from "./ChatMessageItem.vue";
import FileUpload from "../common/FileUpload.vue";
import ChatEmotion from "./ChatEmotion.vue";
import ChatRecord from "./ChatRecord.vue";
import ChatHistory from "./ChatHistory.vue";
import ChatAtBox from "./ChatAtBox.vue"
import GroupMemberSelector from "../group/GroupMemberSelector.vue"
import ChatSelector from "./ChatSelector.vue";
import RtcGroupJoin from "../rtc/RtcGroupJoin.vue"
import ChatInput from "./ChatInput";
import ChatQuoteMessage from "./ChatQuoteMessage.vue";
import ChatTopMessage from "./ChatTopMessage.vue";
import ChatGroupRtcBanner from "./ChatGroupRtcBanner.vue";
import configStore from "../../store/configStore";
import RightMenu from '../../components/common/RightMenu.vue';

export default {
	name: "chatBox",
	components: {
		ChatInput,
		ChatMessageItem,
		FileUpload,
		ChatGroupSide,
		ChatPrivateSide,
		ChatEmotion,
		ChatRecord,
		ChatHistory,
		ChatAtBox,
		GroupMemberSelector,
		RtcGroupJoin,
		ChatQuoteMessage,
		ChatTopMessage,
		ChatGroupRtcBanner,
		ChatSelector,
		RightMenu
	},
	props: {
		conversation: {
			type: Object
		}
	},
	data() {
		return {
			userInfo: {},
			groupId: null,
			isReceipt: true, // 是否回执消息
			showRecord: false, // 是否显示语音录制弹窗
			showSide: false, // 是否显示群聊信息栏
			activeMessageLocalId: '', //选中消息
			selectedMessages: [], // 多选消息数组（使用数组以支持Vue响应式）
			isMultiSelectMode: false, // 是否处于多选模式
			quoteMessage: null, // 被引用的消息
			reqQueue: [], // 等待发送的请求队列
			isSending: false, // 是否正在发消息
			lastScrollTime: 0
		}
	},
	methods: {
		onClickChatBox() {
			// 关闭表情窗口
			this.$refs.emoBox.close();
			// 取消消息选中
			this.activeMessageLocalId = '';
			// 如果不在多选模式，点击空白区域退出多选模式
			if (this.isMultiSelectMode) {
				this.exitMultiSelectMode();
			}
		},
		enterMultiSelectMode(message) {
			this.isMultiSelectMode = true;
			this.selectedMessages = [];
			this.toggleMessageSelect(message);
		},
		exitMultiSelectMode() {
			this.isMultiSelectMode = false;
			this.selectedMessages = [];
		},
		isAllowSelectMessage(message) {
			return this.$msgType.isNormal(message.type) || this.$msgType.isAction(message.type);
		},
		toggleMessageSelect(message) {
			if (!this.isMultiSelectMode) {
				this.enterMultiSelectMode(message);
				return;
			}
			const index = this.selectedMessages.indexOf(message);
			if (index > -1) {
				// 取消选中
				this.selectedMessages.splice(index, 1);
			} else {
				// 检查是否已达到最大选择数量
				if (this.selectedMessages.length >= 20) {
					this.$message.warning(this.$t('chat.maxSelect20'));
					return;
				}
				// 选中
				this.selectedMessages.push(message);
			}
			// 如果没有选中任何消息，退出多选模式
			if (this.selectedMessages.length === 0) {
				this.exitMultiSelectMode();
			}
		},
		isMessageSelected(message) {
			return this.selectedMessages.indexOf(message) > -1;
		},
		onCall(type) {
			if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VOICE) {
				this.showPrivateVideo('voice');
			} else if (type == this.$enums.MESSAGE_TYPE.ACT_RT_VIDEO) {
				this.showPrivateVideo('video');
			}
		},
		onSwitchReceipt() {
			this.isReceipt = !this.isReceipt;
		},
		async onImageBefore(file) {
			const url = URL.createObjectURL(file);
			const data = {
				originUrl: url,
				thumbUrl: url
			}
			const message = {
				localId: this.$nextSnowflakeId(),
				content: JSON.stringify(data),
				type: this.$enums.MESSAGE_TYPE.IMAGE,
				receipt: this.isReceipt
			}
			// 填充对方id
			this.fillTargetId(message, this.conversation.targetId);
			this.isReceipt = false;
			// 本地消息
			const localMessage = this.buildLocalMessage(message);
			// 插入消息
			await this.insertMessage(localMessage)
			// 借助file对象保存
			file.message = message;
			file.localMessage = localMessage;
			file.conversation = this.conversation;
			// 更新图片尺寸
			const size = await this.getImageSize(file)
			data.width = size.width;
			data.height = size.height;
			localMessage.content = JSON.stringify(data)
			await this.chatStore.updateMessage(this.conversation.key, localMessage);
			this.scrollToBottom();
		},
		async onImageSuccess(data, file) {
			const message = file.message;
			message.content = JSON.stringify(data);
			await this.processSendMessage(file.conversation, message, file.localMessage);
		},
		async onImageFail(e, file) {
			const localMessage = file.localMessage;
			localMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
			await this.chatStore.updateMessage(this.conversation.key, localMessage);
		},
		async onFileBefore(file) {
			const url = URL.createObjectURL(file);
			const data = {
				name: file.name,
				size: file.size,
				url: url
			}
			const message = {
				localId: this.$nextSnowflakeId(),
				content: JSON.stringify(data),
				type: this.$enums.MESSAGE_TYPE.FILE,
				receipt: this.isReceipt
			}
			// 填充对方id
			this.fillTargetId(message, this.conversation.targetId);
			this.isReceipt = false;
			// 本地消息
			const localMessage = this.buildLocalMessage(message);
			// 插入消息
			await this.insertMessage(localMessage)
			// 借助file对象保存
			file.message = message;
			file.localMessage = localMessage;
			file.conversation = this.conversation;
		},
		async onFileSuccess(url, file) {
			const data = {
				name: file.name,
				size: file.size,
				url: url
			}
			const message = file.message;
			message.content = JSON.stringify(data);
			await this.processSendMessage(file.conversation, message, file.localMessage);
		},
		async onFileFail(e, file) {
			const localMessage = file.localMessage;
			localMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
			await this.chatStore.updateMessage(this.conversation.key, localMessage);
		},
		async onVideoBefore(file) {
			const url = URL.createObjectURL(file);
			const data = {
				videoUrl: url
			}
			const message = {
				localId: this.$nextSnowflakeId(),
				content: JSON.stringify(data),
				type: this.$enums.MESSAGE_TYPE.VIDEO,
				receipt: this.isReceipt
			}
			// 填充对方id
			this.fillTargetId(message, this.conversation.targetId);
			this.isReceipt = false;
			// 本地消息
			const localMessage = this.buildLocalMessage(message);
			// 插入消息
			await this.insertMessage(localMessage)
			// 借助file对象保存
			file.message = message;
			file.localMessage = localMessage;
			file.conversation = this.conversation;
			// 更新视频尺寸
			const size = await this.getVideoSize(file)
			data.width = size.width;
			data.height = size.height;
			localMessage.content = JSON.stringify(data)
			await this.chatStore.updateMessage(this.conversation.key, localMessage);
			this.scrollToBottom();
		},
		async onVideoSuccess(data, file) {
			const message = file.message;
			message.content = JSON.stringify(data);
			await this.processSendMessage(file.conversation, message, file.localMessage);
		},
		async onVideoFail(e, file) {
			const localMessage = file.localMessage;
			localMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
			await this.chatStore.updateMessage(this.conversation.key, localMessage);
		},
		onClickMore() {
			this.showSide = !this.showSide;
			if (this.showSide && this.isGroup) {
				// 刷新一下群和成员信息
				this.loadGroup(this.group.id);
			}
		},
		async onScroll(e) {
			let scrollElement = e.target
			let scrollTop = scrollElement.scrollTop
			// 滚到顶部
			if (scrollTop < 30) {
				if (new Date().getTime() - this.lastScrollTime < 500) {
					return;
				}
				this.lastScrollTime = new Date().getTime();
				if (!this.chatStore.hasMoreLastMessage) {
					this.$message.success(this.$t('chat.noMoreHistory'));
					return;
				}
				const hst = scrollElement.scrollHeight;
				await this.chatStore.loadLastPageMessage(this.conversation.key, 30);
				await this.$nextTick();
				// 恢复滚动条位置
				scrollElement.scrollTop = scrollElement.scrollHeight - hst;
				// 清除底部标志
				this.chatStore.setIsInBottom(false);
			}
			// 滚到底部
			if (scrollTop + scrollElement.clientHeight >= scrollElement.scrollHeight - 30) {
				if (new Date().getTime() - this.lastScrollTime < 500) {
					return;
				}
				this.lastScrollTime = new Date().getTime();
				if (this.chatStore.hasMoreNextMessage) {
					// 向下翻页
					await this.chatStore.loadNextPageMessage(this.conversation.key, 30);
				}
				// 设置底部标志
				this.chatStore.setIsInBottom(!this.chatStore.hasMoreNextMessage);
			}
		},
		showEmotionBox() {
			let width = this.$refs.emotion.offsetWidth;
			let left = this.$elm.fixLeft(this.$refs.emotion);
			let top = this.$elm.fixTop(this.$refs.emotion);
			this.$refs.emoBox.open({
				x: left + width / 2,
				y: top
			})
		},
		onScreenshot() {
			window.electronAPI.invoke('screenshot').then((buffer) => {
				if (buffer) {
					// 粘贴截图到聊天编辑框
					this.$refs.chatInputEditor.pasteScreenShot(buffer);
				}
			})
		},
		onShowScreenshotMenu(e) {
			let menuItems = [{
				key: 'SCREEN_SHOT',
				name: this.$t('chat.screenshotHideWindow'),
			}];
			this.$refs.rightMenu.open(e, menuItems)
		},
		screenshotAndHideWin() {
			// 隐藏当前窗口
			window.electronAPI.sendEvent("close");
			setTimeout(() => {
				window.electronAPI.invoke('screenshot').then((buffer) => {
					if (buffer) {
						// 粘贴截图到聊天编辑框
						this.$refs.chatInputEditor.pasteScreenShot(buffer);
					}
					// 截图完成后还原窗口
					window.electronAPI.sendEvent("show");
				})
			}, 100)
		},
		onSelectMenu(item) {
			switch (item.key) {
				case "SCREEN_SHOT":
					this.screenshotAndHideWin();
					break;
			}
		},
		onEmotion(payload) {
			if (typeof payload === 'string') {
				this.$refs.chatInputEditor.insertEmoji(payload);
				return;
			}
			if (payload && payload.type === 'sticker' && payload.data) {
				this.sendStickerMessage(payload.data);
			}
		},
		showRecordBox() {
			this.showRecord = true;
		},
		closeRecordBox() {
			this.showRecord = false;
		},
		showPrivateVideo(mode) {
			if (!this.isFriend) {
				this.$message.error(this.$t('chat.notFriendCall'));
				return
			}
			if (this.userStore.isInRtc) {
				this.$message.error(this.$t('chat.inCall'));
				return;
			}
			let rtcInfo = {
				mode: mode,
				isHost: true,
				friend: this.friend,
			}
			// 通过home.vue打开单人视频窗口
			this.$eventBus.$emit("openPrivateVideo", rtcInfo);
		},
		onGroupVideo() {
			if (this.userStore.isInRtc) {
				this.$message.error(this.$t('chat.inCall'));
				return;
			}
			this.$http({
				url: "/webrtc/group/info?groupId=" + this.group.id,
				method: 'GET'
			}).then((rtcInfo) => {
				if (rtcInfo.isChating) {
					// 已在通话中，可以直接加入通话
					this.$refs.rtcJoin.open(rtcInfo);
				} else {
					// 邀请成员发起通话
					let ids = [this.mine.id];
					let maxChannel = this.configStore.webrtc.maxChannel;
					this.$refs.rtcSel.open(maxChannel, ids, ids, []);
				}
			})
		},
		onInviteOk(members) {
			if (members.length < 2) {
				return;
			}
			let userInfos = [];
			members.forEach(m => {
				userInfos.push({
					id: m.userId,
					nickName: m.showNickName,
					headImage: m.headImage,
					isCamera: false,
					isMicroPhone: true,
					isShareScreen: false
				})
			})
			let rtcInfo = {
				isHost: true,
				groupId: this.group.id,
				inviterId: this.mine.id,
				userInfos: userInfos
			}
			// 通过home.vue打开多人视频窗口
			this.$eventBus.$emit("openGroupVideo", rtcInfo);
		},
		showHistoryBox() {
			this.$refs.chatHistory.open();
		},
		async onSendRecord(data) {
			const message = {
				localId: this.$nextSnowflakeId(),
				content: JSON.stringify(data),
				type: this.$enums.MESSAGE_TYPE.AUDIO,
				receipt: this.isReceipt
			}
			// 填充对方id
			this.fillTargetId(message, this.conversation.targetId);
			this.isReceipt = false;
			// 本地消息	
			const localMessage = this.buildLocalMessage(message);
			await this.insertMessage(localMessage);
			await this.processSendMessage(this.conversation, message, localMessage);
			// 关闭录音窗口
			this.showRecord = false;
			// 保持输入框焦点
			this.$refs.chatInputEditor.focus();
		},
		fillTargetId(message, targetId) {
			if (this.isGroup) {
				message.groupId = targetId;
			} else {
				message.recvId = targetId;
			}
		},
		notifySend() {
			this.$refs.chatInputEditor.submit();
		},
		async sendMessage(fullList) {
			this.resetEditor();
			this.readedMessage();
			let sendText = this.isReceipt ? this.$t("chat.receiptMessage") : "";
			fullList.forEach(async msg => {
				switch (msg.type) {
					case "text":
						await this.sendTextMessage(sendText + msg.content, msg.atUserIds);
						break;
					case "image":
						await this.sendImageMessage(msg.content.file);
						break;
					case "file":
						await this.sendFileMessage(msg.content.file);
						break;
				}
			})
		},
		async sendImageMessage(file) {
			await this.onImageBefore(file);
			const formData = new FormData()
			formData.append('file', file)
			this.$http.post("/image/upload?isPermanent=false", formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((data) => {
				this.onImageSuccess(data, file);
			}).catch((res) => {
				this.onImageFail(res, file);
			})
			this.$nextTick(() => this.$refs.chatInputEditor.focus());
			this.scrollToBottom();
		},
		async sendTextMessage(sendText, atUserIds) {
			if (!sendText.trim()) {
				return;
			}
			const message = {
				localId: this.$nextSnowflakeId(),
				content: sendText,
				type: this.$enums.MESSAGE_TYPE.TEXT
			}
			// 填充对方id
			this.fillTargetId(message, this.conversation.targetId);
			// 被@人员列表
			if (this.isGroup) {
				message.atUserIds = atUserIds;
				message.receipt = this.isReceipt;
			}
			// 引用消息
			if (this.quoteMessage) {
				message.quoteMessageId = this.quoteMessage.id
			}
			// 本地消息
			const localMessage = this.buildLocalMessage(message);
			localMessage.quoteMessage = this.quoteMessage;
			await this.insertMessage(localMessage);
			// 清空标志
			this.isReceipt = false;
			this.quoteMessage = null;
			// 发送
			await this.processSendMessage(this.conversation, message, localMessage);
		},
		async sendFileMessage(file) {
			let check = this.$refs.fileUpload.beforeUpload(file);
			if (check) {
				this.$refs.fileUpload.onFileUpload({ file });
			}
		},
		onCopyMessage(message) {
			// 使用现代浏览器的 Clipboard API
			if (navigator.clipboard && window.isSecureContext) {
				navigator.clipboard.writeText(message.content).then(() => {
					this.$message.success(this.$t('chat.copySuccess2'));
				}).catch(() => {
					this.$message.error(this.$t('chat.copyFailed'));
				});
			} else {
				this.$message.error(this.$t('chat.copyFailed'));
			}
		},
		async onResendMessage(message) {
			if (message.type != this.$enums.MESSAGE_TYPE.TEXT) {
				this.$message.error(this.$t('chat.resendNotSupport'))
				return;
			}
			// 删除旧消息
			await this.chatStore.deleteMessage(this.conversation.key, message);
			// 重新推送
			const sendMessage = JSON.parse(JSON.stringify(message));
			sendMessage.localId = this.$nextSnowflakeId();
			const localMessage = this.buildLocalMessage(sendMessage);
			await this.insertMessage(localMessage);
			await this.processSendMessage(this.conversation, sendMessage, localMessage);
		},
		onMessageClick(e, message) {
			if (this.isMultiSelectMode) {
				// 选中
				if (this.isAllowSelectMessage(message)) {
					this.toggleMessageSelect(message);
				}
				e.stopPropagation();
			}
		},
		onMultiSelectMessage(message) {
			// 进入多选模式
			this.enterMultiSelectMode(message);
		},
		onDeleteMessage(message) {
			this.$confirm(this.$t('chat.deleteMsgConfirm'), this.$t('chat.deleteMsgTitle'), {
				confirmButtonText: this.$t('common.ok'),
				cancelButtonText: this.$t('common.cancel'),
				type: 'warning'
			}).then(async () => {
				const convKey = this.conversation.key;
				if (message.id) {
					const data = {
						chatId: this.conversation.targetId,
						messageIds: [message.id]
					}
					await this.$http({
						url: `/message/${this.chatTypeText(this.conversation)}/deleteMessage`,
						method: 'delete',
						data: data
					});
				}
				this.chatStore.deleteMessage(convKey, message);
			});
		},
		onAddToSticker(message) {
			const sticker = JSON.parse(message.content);
			this.$http({
				url: '/sticker/custom/add',
				method: 'post',
				data: sticker
			}).then(() => {
				this.$message.success(this.$t('chat.addStickerSuccess'));
				// 刷新表情面板的自定义表情列表
				if (this.$refs.emoBox && this.$refs.emoBox.refreshCustomStickers) {
					this.$refs.emoBox.refreshCustomStickers();
				}
			})
		},
		onDownloadFile(message) {
			const url = JSON.parse(message.content).url;
			const name = JSON.parse(message.content).name;
			let a = document.createElement('a')
			a.download = name
			a.style.display = 'none'
			a.href = url
			a.target = "_blank"
			document.body.appendChild(a)
			a.click()
			document.body.removeChild(a)
		},
		// 批量删除消息
		onBatchDelete() {
			if (this.selectedMessages.length === 0) {
				this.$message.warning(this.$t('chat.selectToDelete'));
				return;
			}
			this.$confirm(this.$t('chat.batchDeleteConfirm', { n: this.selectedMessages.length }), this.$t('chat.batchDeleteTitle'), {
				confirmButtonText: this.$t('common.ok'),
				cancelButtonText: this.$t('common.cancel'),
				type: 'warning'
			}).then(async () => {
				const convKey = this.conversation.key;
				const ids = this.selectedMessages.filter(m => m.id).map(m => m.id);
				if (ids.length > 0) {
					const data = {
						chatId: this.conversation.targetId,
						messageIds: ids
					}
					await this.$http({
						url: `/message/${this.chatTypeText()}/deleteMessage`,
						method: 'delete',
						data: data
					});
				}
				this.selectedMessages.forEach(message => {
					this.chatStore.deleteMessage(convKey, message);
				});
				this.exitMultiSelectMode();
				this.$message.success(this.$t('chat.deleteSuccess'));
			});
		},
		// 批量转发消息（逐条转发）
		onBatchForward() {
			if (this.selectedMessages.length === 0) {
				this.$message.warning(this.$t('chat.selectToForward'));
				return;
			}
			// 需要过滤掉的消息类型
			const filteredTypes = [
				this.$enums.MESSAGE_TYPE.ACT_RT_VOICE, // 语音通话
				this.$enums.MESSAGE_TYPE.ACT_RT_VIDEO, // 视频通话
				this.$enums.MESSAGE_TYPE.USER_CARD, // 个人名片
				this.$enums.MESSAGE_TYPE.GROUP_CARD // 群名片
			];
			// 统计被过滤的消息（未发送成功的消息 + 不支持转发的消息类型）
			const forwardableMessages = this.selectedMessages.filter(m =>
				m.id && !filteredTypes.includes(m.type)
			);
			// 如果有被过滤的消息，提示用户
			if (forwardableMessages.length < this.selectedMessages.length) {
				this.$confirm(this.$t('chat.forwardTip'), this.$t('common.tip'), {
					confirmButtonText: this.$t('chat.continueSend'),
					cancelButtonText: this.$t('common.cancel'),
					type: 'warning'
				}).then(() => {
					// 用户确认后继续转发
					this.doBatchForward(forwardableMessages);
				})
				return;
			}
			this.doBatchForward(forwardableMessages);
		},
		// 执行批量转发
		async doBatchForward(forwardableMessages) {
			if (forwardableMessages.length === 0) {
				this.$message.warning(this.$t('chat.noForwardMsg'));
				return;
			}
			this.$refs.chatSel.open(async (conversations) => {
				this.exitMultiSelectMode();
				// 逐个会话逐条发送消息，保证顺序
				let successCount = 0;
				let totalCount = conversations.length * forwardableMessages.length;
				let completedCount = 0;
				// 对每个会话串行发送消息
				for (const conv of conversations) {
					// 对每条消息串行发送，保证顺序
					for (const forwardMessage of forwardableMessages) {
						try {
							let message = {
								localId: this.$nextSnowflakeId(),
								content: forwardMessage.content,
								type: forwardMessage.type
							}
							if (conv.type == this.$enums.CONVERSATION_TYPE.GROUP) {
								message.groupId = conv.targetId
							} else {
								message.recvId = conv.targetId;
							}
							const m = await this.$http({
								url: `/message/${this.chatTypeText(conv)}/send`,
								method: 'post',
								data: message
							});
							m.selfSend = true;
							this.chatStore.openChat(conv);
							this.chatStore.insertMessage(conv.key, m);
							successCount++;
						} finally {
							completedCount++;
							// 所有消息发送完成
							if (completedCount === totalCount) {
								if (successCount === totalCount) {
									this.$message.success(this.$t('chat.forwardSuccessToChats', { n: forwardableMessages.length, m: conversations.length }));
								} else {
									this.$message.warning(this.$t('chat.forwardPartialFail', { success: successCount, total: totalCount }));
								}
							}
						}
					}
				}
			});
		},
		// 合并转发消息
		onMergeForward() {
			if (this.selectedMessages.length < 2) {
				this.$message.warning(this.$t('chat.mergeForwardMin2'));
				return;
			}
			// 过滤出已发送成功的消息（有id的消息）
			const forwardableMessages = this.selectedMessages.filter(m => m.id).sort((a, b) => a.id - b.id);
			// 统计未发送成功的消息
			const unsentMessages = this.selectedMessages.filter(m => !m.id);
			// 如果有未发送成功的消息，提示用户
			if (unsentMessages.length > 0) {
				this.$confirm(this.$t('chat.unsentForwardTip', { n: unsentMessages.length }), this.$t('common.tip'), {
					confirmButtonText: this.$t('chat.continueSend'),
					cancelButtonText: this.$t('common.cancel'),
					type: 'warning'
				}).then(() => {
					// 用户确认后继续转发
					this.doMergeForward(forwardableMessages);
				})
				return;
			}
			this.doMergeForward(forwardableMessages);
		},
		// 执行合并转发
		doMergeForward(forwardableMessages) {
			if (forwardableMessages.length === 0) {
				this.$message.warning(this.$t('chat.noForwardMsg'));
				return;
			}
			// 使用 key+params 存储 title，语言切换时自动渲染
			let title;
			if (this.isGroup) {
				title = JSON.stringify({ key: 'merge.title.groupChatHistory', params: [this.group.name] });
			} else {
				title = JSON.stringify({ key: 'merge.title.privateChatHistory', params: [this.conversation.showName, this.mine.nickName] });
			}
			// 构建合并转发的数据
			const mergeData = {
				messages: forwardableMessages.map(m => {
					const message = {
						id: m.id,
						type: m.type,
						sendId: m.sendId,
						sendNickName: this.showName(m),
						sendHeadImage: this.headImage(m),
						sendTime: m.sendTime,
						content: m.content
					}
					if (m.type == this.$enums.MESSAGE_TYPE.MERGE_FORWARD) {
						// 合并转发里面又嵌套了合并转发内容，清空消息体避免报文体积过大
						const mergeData = JSON.parse(m.content)
						mergeData.messages = mergeData.messages.map(m => m.id);
						message.content = JSON.stringify(mergeData);
					}
					return message;
				}),
				title: title,
				convType: this.conversation.type
			};
			// 用户确认后，打开会话选择器
			this.$refs.chatSel.open(conversations => {
				this.exitMultiSelectMode();
				// 发送合并转发消息
				let successCount = 0;
				let totalCount = conversations.length;
				let completedCount = 0;
				conversations.forEach(conv => {
					let message = {
						content: JSON.stringify(mergeData),
						type: this.$enums.MESSAGE_TYPE.MERGE_FORWARD
					}
					if (conv.type == this.$enums.CONVERSATION_TYPE.GROUP) {
						message.groupId = conv.targetId
					} else {
						message.recvId = conv.targetId;
					}
					this.$http({
						url: this.messageAction(conv),
						method: 'post',
						data: message
					}).then(async (m) => {
						m.selfSend = true;
						await this.chatStore.openChat(conv);
						await this.chatStore.insertMessage(conv.key, m);
						successCount++;
					}).finally(() => {
						completedCount++;
						if (completedCount === totalCount) {
							if (successCount === totalCount) {
								this.$message.success(this.$t('chat.mergeForwardSuccessToChats', { n: forwardableMessages.length, m: totalCount }));
							} else {
								this.$message.warning(this.$t('chat.mergeForwardPartialFail', { success: successCount, total: totalCount }));
							}
						}
					})
				})
			});
		},
		onRecallMessage(message) {
			this.$confirm(this.$t('chat.recallConfirm'), this.$t('chat.recallTitle'), {
				confirmButtonText: this.$t('common.ok'),
				cancelButtonText: this.$t('common.cancel'),
				type: 'warning'
			}).then(() => {
				const convKey = this.conversation.key;
				const url = `/message/${this.chatTypeText()}/recall/${message.id}`
				this.$http({
					url: url,
					method: 'delete'
				}).then((m) => {
					this.$message.success(this.$t('chat.recallMsgSuccess'));
					m.selfSend = true;
					this.chatStore.recallMessage(convKey, m);
				})
			});
		},
		onQuoteMessage(message) {
			this.quoteMessage = message;
		},
		onForwardMessage(forwardMessage) {
			this.$refs.chatSel.open(conversations => {
				// 逐个会话发送消息
				let idx = 0;
				conversations.forEach(conv => {
					const message = {
						localId: this.$nextSnowflakeId(),
						content: forwardMessage.content,
						type: forwardMessage.type
					}
					if (conv.type == this.$enums.CONVERSATION_TYPE.GROUP) {
						message.groupId = conv.targetId
					} else {
						message.recvId = conv.targetId;
					}
					this.$http({
						url: `/message/${this.chatTypeText(conv)}/send`,
						method: 'post',
						data: message
					}).then(async (m) => {
						m.selfSend = true;
						await this.chatStore.openChat(conv);
						await this.chatStore.insertMessage(conv.key, m);
						if (++idx == conversations.length) {
							this.$message.success(this.$t('chat.forwardSuccess'))
						}
					})
				})
			});
		},
		onTopMessage(message) {
			this.$http({
				url: `/group/setTopMessage/${message.groupId}?messageId=${message.id}`,
				method: 'post'
			}).then(() => { })
		},
		onLocateQuoteMessage(message) {
			this.locateMessage(message.quoteMessage);
		},
		async locateMessage(message) {
			const localId = message.localId;
			const locateMessage = await this.$db.findMessageByLocalId(localId);
			if (!locateMessage || locateMessage.deleted || this.isRecall(locateMessage)) {
				this.$message.error(this.$t('chat.locateFail'));
				return;
			}
			await this.chatStore.locateToMessage(this.conversation.key, locateMessage)
			// 定位消息
			this.scrollToMessage(localId, 100, 0);
			// 选中消息
			this.activeMessageLocalId = localId;
			// 设置底部标记
			this.chatStore.setIsInBottom(!this.chatStore.hasMoreNextMessage);
			// 关闭聊天记录
			this.$refs.chatHistory.close();
		},
		scrollToMessage(id, delay, times) {
			setTimeout(() => {
				let messgaeItem = document.getElementById(id);
				if (messgaeItem) {
					messgaeItem.scrollIntoView({ behavior: 'smooth' });
				} else if (times < 3) {
					this.scrollToMessage(id, delay * 3, times + 1)
				} else {
					console.log("消息定位失败", delay)
				}
			}, delay)
		},
		async scrollToAtMessage() {
			if (this.conversation.lastAtMessageId < 0) {
				return;
			}
			const atMessage = await this.$db.findMessageById(this.conversation.lastAtMessageId, this.conversation.key);
			if (!atMessage) {
				this.$message.error(this.$t('chat.locateFail'));
				return;
			}
			await this.locateMessage(atMessage);
			await this.chatStore.resetAtMessage(this.conversation.key);
		},
		async readedMessage() {
			if (this.conversation.unreadCount > 0) {
				const convKey = this.conversation.key;
				this.chatStore.resetUnreadCount(convKey);
				const tid = this.conversation.targetId;
				let url = "";
				if (this.isGroup) {
					url = `/message/group/readed?groupId=${tid}&messageId=${this.maxMessageId}`;
				} else {
					url = `/message/private/readed?friendId=${tid}&messageId=${this.maxMessageId}`;
				}
				await this.$http({
					url: url,
					method: 'put'
				})
			}
		},
		async loadReaded(fId) {
			const convKey = this.conversation.key;
			const messageId = await this.$http({
				url: `/message/private/maxReadedId?friendId=${fId}`,
				method: 'get'
			})
			this.chatStore.readedMessage(convKey, messageId);
		},
		async loadGroup(groupId) {
			this.groupId = groupId;
			const group = await this.$http({
				url: `/group/find/${groupId}`,
				method: 'get'
			})
			await this.chatStore.updateFromGroup(group);
			this.groupStore.updateGroup(group);
			this.groupStore.refreshMember(groupId);
		},
		async updateFriendInfo() {
			if (this.isFriend) {
				// store的数据不能直接修改，深拷贝一份store的数据
				const friend = JSON.parse(JSON.stringify(this.friend));
				friend.headImage = this.userInfo.headImageThumb;
				friend.nickName = this.userInfo.nickName;
				friend.showNickName = friend.remarkNickName ? friend.remarkNickName : friend.nickName;
				await this.chatStore.updateFromFriend(friend);
				this.friendStore.updateFriend(friend);
			} else {
				await this.chatStore.updateFromUser(this.userInfo);
			}
		},
		async loadFriend(friendId) {
			// 获取好友信息
			const userInfo = await this.$http({
				url: `/user/find/${friendId}`,
				method: 'GET'
			});
			this.userInfo = userInfo;
			await this.updateFriendInfo();
		},
		showName(message) {
			if (!message) return "";
			if (this.isGroup) {
				const member = this.groupMemberMap.get(message.sendId);
				return member ? member.showNickName : "";
			} else if (message.sendId == this.mine.id) {
				return this.mine.nickName;
			} else {
				return this.conversation.showName;
			}
		},
		headImage(message) {
			if (this.isGroup) {
				const member = this.groupMemberMap.get(message.sendId);
				return member ? member.headImage : "";
			} else {
				return message.selfSend ? this.mine.headImageThumb : this.conversation.headImage
			}
		},
		onAtMember(member) {
			this.$refs.chatInputEditor.insertAtMember(member);
		},
		resetEditor() {
			this.$nextTick(() => {
				this.$refs.chatInputEditor.clear();
				this.$refs.chatInputEditor.focus();
			});
		},
		async onScrollToBottom() {
			await this.chatStore.resetMessages(this.conversation.key);
			this.scrollToBottom();
		},
		async scrollToBottom() {
			this.$nextTick(() => {
				let div = document.getElementById("chatScrollBox");
				div.scrollTop = div.scrollHeight;
				this.chatStore.setIsInBottom(true);
			});
		},
		async processSendMessage(conv, message, localMessage) {
			// 发送
			const m = await this.sendMessageRequest(conv, message).catch(async (e) => {
				// 更新本地消息
				console.log(e)
				localMessage.status = this.$enums.MESSAGE_STATUS.FAILED;
				await this.chatStore.updateMessage(conv.key, localMessage);
			})
			if (m) {
				// 更新本地消息
				m.selfSend = true;
				m.convKey = conv.key;
				await this.chatStore.updateMessage(conv.key, m);
			}
		},
		sendMessageRequest(conv, message) {
			return new Promise((resolve, reject) => {
				// 请求入队列，防止请求"后发先至"，导致消息错序
				const action = this.messageAction(conv)
				this.reqQueue.push({ action, message, resolve, reject });
				this.processReqQueue();
			})
		},
		processReqQueue() {
			if (this.reqQueue.length && !this.isSending) {
				this.isSending = true;
				const reqData = this.reqQueue.shift();
				this.$http({
					url: reqData.action,
					method: 'post',
					data: reqData.message
				}).then((res) => {
					reqData.resolve(res)
				}).catch((e) => {
					reqData.reject(e)
				}).finally(() => {
					this.isSending = false;
					// 发送下一条请求
					this.processReqQueue();
				})
			}
		},
		buildLocalMessage(message) {
			const m = JSON.parse(JSON.stringify(message));
			m.convKey = this.conversation.key;
			m.seqNo = Math.max(1, this.conversation.maxSeqNo);
			m.sendId = this.mine.id;
			m.sendTime = new Date().getTime();
			m.status = this.$enums.MESSAGE_STATUS.SENDING;
			m.selfSend = true;
			if (this.isGroup) {
				m.readedCount = 0;
			}
			if (message.quoteMessageId) {
				m.quoteMessage = this.quoteMessage;
			}
			return m;
		},
		getImageSize(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.onload = function (event) {
					const img = new Image();
					img.onload = function () {
						resolve({ width: img.width, height: img.height });
					};
					img.onerror = function () {
						reject(new Error('无法加载图片'));
					};
					img.src = event.target.result;
				};
				reader.onerror = function () {
					reject(new Error('无法读取文件'));
				};
				reader.readAsDataURL(file);
			});
		},
		getVideoSize(file) {
			return new Promise((resolve) => {
				const url = URL.createObjectURL(file);
				const video = document.createElement('video');
				video.onloadedmetadata = () => {
					resolve({
						width: video.videoWidth,
						height: video.videoHeight
					});
					URL.revokeObjectURL(url);
				};
				video.src = url;
			});
		},
		async sendStickerMessage(sticker) {
			const message = {
				localId: this.$nextSnowflakeId(),
				content: JSON.stringify(sticker),
				type: this.$enums.MESSAGE_TYPE.STICKER,
				receipt: this.isReceipt
			};
			this.fillTargetId(message, this.conversation.targetId);
			this.isReceipt = false;
			const localMessage = this.buildLocalMessage(message);
			await this.insertMessage(localMessage);
			await this.processSendMessage(this.conversation, message, localMessage);
		},
		async insertMessage(message) {
			if (!this.chatStore.isInBottom) {
				await this.chatStore.resetMessages(this.conversation.key);
			}
			await this.chatStore.insertMessage(this.conversation.key, message)
			await this.chatStore.moveTop(this.conversation.key);
			this.scrollToBottom();
		},
		messageAction(conv) {
			return `/message/${this.chatTypeText(conv)}/send`;
		},
		chatTypeText(conv) {
			conv = conv ? conv : this.conversation;
			return conv.type == this.$enums.CONVERSATION_TYPE.PRIVATE ? "private" : "group";
		},
		isRecall(m) {
			return m.status == this.$enums.MESSAGE_STATUS.RECALL;
		}
	},
	computed: {
		mine() {
			return this.userStore.userInfo;
		},
		isFriend() {
			return this.friendStore.isFriend(this.userInfo.id);
		},
		friend() {
			return this.friendStore.findFriend(this.userInfo.id) || {}
		},
		group() {
			return this.groupStore.findGroup(this.groupId) || {}
		},
		groupMembers() {
			return this.group.members || [];
		},
		groupMemberMap() {
			return new Map(this.groupMembers.map(m => [m.userId, m]));
		},
		title() {
			let title = this.conversation.showName;
			if (this.isGroup) {
				let size = this.groupMembers.filter(m => !m.quit).length;
				title += `(${size})`;
			}
			return title;
		},
		unreadCount() {
			return this.conversation.unreadCount;
		},
		messages() {
			return this.chatStore.messages;
		},
		isPrivate() {
			return this.$enums.CONVERSATION_TYPE.PRIVATE == this.conversation.type
		},
		isGroup() {
			return this.$enums.CONVERSATION_TYPE.GROUP == this.conversation.type
		},
		isOwner() {
			return this.group.ownerId == this.mine.id;
		},
		isManager() {
			const m = this.groupMemberMap.get(this.mine.id);
			return m && m.isManager;
		},
		loading() {
			return this.chatStore.loading;
		},
		maxMessageId() {
			return this.conversation.maxMessageId;
		},
		notAllowInputTip() {
			if (this.isGroup) {
				if (this.group.dissolve) {
					return this.$t('chat.inputDisabledGroupDissolved')
				} else if (this.group.quit) {
					return this.$t('chat.inputDisabledGroupQuit')
				} else if (this.group.isBanned) {
					if (this.group.unbanTime) {
						return this.$t('chat.inputDisabledGroupBannedWithTime', {
							reason: this.group.reason,
							time: this.group.unbanTime
						});
					}
					return this.$t('chat.inputDisabledGroupBanned', {
						reason: this.group.reason
					});
				} else if (this.group.isAllMuted && !this.isOwner && !this.isManager) {
					return this.$t('chat.inputDisabledAllMuted')
				} else if (this.group.isMuted) {
					return this.$t('chat.inputDisabledMuted')
				}
			} else if (this.userInfo.isBanned) {
				if (this.userInfo.unbanTime) {
					return this.$t('chat.inputDisabledPeerBannedWithTime', {
						reason: this.userInfo.reason,
						time: this.userInfo.unbanTime
					});
				}
				return this.$t('chat.inputDisabledPeerBanned', {
					reason: this.userInfo.reason
				});
			}
			return "";
		}
	},
	watch: {
		conversation: {
			async handler(newConv, oldConv) {
				if (!oldConv || newConv.key != oldConv.key) {
					this.userInfo = {};
					this.groupId = null;
					if (this.isGroup) {
						this.loadGroup(this.conversation.targetId);
					} else {
						this.loadFriend(this.conversation.targetId);
						// 加载已读状态
						this.loadReaded(this.conversation.targetId)
					}
					// 重置消息
					await this.chatStore.resetMessages(this.conversation.key)
					// 滚到底部
					this.scrollToBottom();
					// 有时页面渲染得慢，会导致无法正常滚到底部，这里再滚一次
					setTimeout(() => this.scrollToBottom(), 100);
					this.showSide = false;
					// 消息已读
					this.readedMessage();
					// 复位回执消息
					this.isReceipt = false;
					// 清空引用消息
					this.quoteMessage = null;
					// 退出多选模式
					this.exitMultiSelectMode();
					// 保存草稿
					this.$refs.chatInputEditor.saveDraft(oldConv);
					// 恢复草稿
					this.$refs.chatInputEditor.restoreDraft(newConv);
				}
			},
			immediate: true
		},
		loading: {
			async handler(newLoading, oldLoading) {
				if (newLoading) return;
				// 断线重连后，需要更新一下已读状态	
				if (this.isPrivate) {
					this.loadReaded(this.conversation.targetId);
				}
				// 如果用户所在的会话拉到了新的离线消息，需重置会话内的消息，否则新消息会不显示
				if (this.chatStore.hasMoreLastMessage) {
					await this.chatStore.resetMessages(this.conversation.key);
					this.scrollToBottom();
				}
			}
		}
	},
	mounted() {
		let div = document.getElementById("chatScrollBox");
		div.addEventListener('scroll', this.onScroll)
		this.$eventBus.$on('newMessage', async (message) => {
			// 收到新消息,则滚动至底部
			if (this.$msgType.isNormal(message.type) || this.$msgType.isAction(message.type)) {
				// 新消息来时，如果用户本来就在底部不远位置，则直接拉到底部
				if (this.chatStore.isInBottom || message.selfSend) {
					this.scrollToBottom();
				}
			}
		});
	}
}
</script>

<style lang="scss">
.chat-box {
	position: relative;
	width: 100%;

	.el-header {
		display: flex;
		padding: 0 12px;
		line-height: 60px;
		border-bottom: var(--im-border);

		.title {
			font-size: var(--im-font-size-larger);
		}


		.btn-side {
			position: absolute;
			right: 20px;
			line-height: 60px;
			font-size: 20px;
			cursor: pointer;
			color: var(--im-text-color-light);
		}
	}

	.content-box {
		position: relative;

		.im-chat-main {
			padding: 0 10px;
			background: #f6f7f8;

			.im-chat-box {
				position: relative;

				.loading-message-tip {
					display: flex;
					align-items: center;
					justify-content: center;
					gap: 6px;
					padding: 10px 0 6px;
					font-size: var(--im-font-size-small);
					color: var(--im-text-color-light);

					.el-icon-loading {
						font-size: 14px;
					}
				}

				&.multi-select-mode {
					>div {
						position: relative;
						cursor: pointer;
						padding-left: 40px;
						transition: background-color 0.2s;

						&:hover {
							background-color: rgba(0, 0, 0, 0.02);
						}

						&.message-selected {
							background-color: var(--im-background-active-dark)
						}
					}

					.message-checkbox {
						position: absolute;
						left: 10px;
						top: 50%;
						transform: translateY(-50%);
						z-index: 10;
					}
				}
			}
		}

		.locate-tip {
			text-align: center;
			position: absolute;
			right: 20px;
			bottom: 230px;
			color: var(--im-color-primary);
			font-size: var(--im-font-size);
			font-weight: 600;
			background: white;
			padding: 8px 16px;
			border-radius: 18px;
			cursor: pointer;
			z-index: 99;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
			transition: all 0.3s ease;
			border: 1px solid rgba(0, 0, 0, 0.06);

			&:hover {
				transform: translateY(-1px);
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
			}
		}

		.im-chat-footer {
			position: relative;
			display: flex;
			flex-direction: column;
			padding: 0;

			.chat-tool-bar {
				display: flex;
				position: relative;
				width: 100%;
				height: 44px;
				text-align: left;
				box-sizing: border-box;
				border-top: 2px solid #EBEEF5;
				padding: 6px 8px;
				align-items: center;
				background: var(--im-background-active);
				color: black;
				gap: 8px;
				opacity: 0.85;

				// 统一所有按钮的样式
				>div,
				>i {
					font-size: 20px;
					cursor: pointer;
					width: 32px;
					height: 32px;
					line-height: 32px;
					text-align: center;
					border-radius: 6px;

					transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
					display: flex;
					align-items: center;
					justify-content: center;
					position: relative;

					&.chat-tool-active {
						color: var(--im-color-primary);
						background: var(--im-background-active-dark);
						transform: scale(1.02);

					}

					&:hover {
						color: var(--im-color-primary);
						background: var(--im-background-active);
						transform: translateY(-1px);
						box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
					}
				}

				// 特殊处理小图标（如el-icon-caret-bottom）
				>i.el-icon-caret-bottom {
					font-size: 14px;
					width: 24px;
					height: 24px;
					line-height: 24px;
				}
			}

			.send-content-area {
				position: relative;
				display: flex;
				flex-direction: column;
				height: 100%;
				background-color: white !important;

				.quote-message {
					position: absolute;
					bottom: 10px;
					left: 10px;
					font-size: 14px;
					max-width: 80%;
					border-radius: 5px;

					&:hover .quote-remove {
						display: block;
					}

					.quote-remove {
						display: none;
						position: absolute;
						top: -8px;
						right: -8px;
						width: 20px;
						height: 20px;
						line-height: 20px;
						font-size: 14px;
						color: white;
						border-radius: 50%;
						background: #aaa;
						cursor: pointer;

						&:hover {
							background: #888;
						}

					}
				}

				.send-btn-area {
					padding: 10px;
					position: absolute;
					bottom: 4px;
					right: 6px;
				}
			}

			.chat-editer-mask {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				background: #f8f8f8d0;
				font-size: var(--im-font-size-large);
				color: var(--im-text-color-light);
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 10px;
				border: 1px solid #ddd;

				.icon {
					font-size: var(--im-font-size-larger);
					margin-right: 3px;
				}
			}
		}
	}

	.chat-side-box {
		border-left: var(--im-border);
		background: #f6f7f8;

		&.fullscreen {
			width: 335px !important;
		}
	}

	.multi-select-toolbar {
		position: absolute;
		bottom: 230px;
		left: 50%;
		transform: translateX(-50%);
		background: white;
		border-radius: 8px;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		padding: 12px 20px;
		display: flex;
		align-items: center;
		gap: 16px;
		z-index: 1000;
		border: 1px solid rgba(0, 0, 0, 0.1);
		min-width: 300px;

		.toolbar-info {
			font-size: var(--im-font-size);
			color: var(--im-text-color);
			font-weight: 500;
			white-space: nowrap;
			display: flex;
			align-items: center;
			gap: 4px;

			.max-limit-tip {
				color: var(--im-color-warning);
				font-size: var(--im-font-size-small);
			}
		}

		.toolbar-actions {
			display: flex;
			gap: 8px;
		}
	}
}
</style>